import type { CheckpointStatus } from '@/types/project'

export const CHECKPOINT_STATUSES: CheckpointStatus[] = ['pending', 'in_transit', 'reached']

const VALUE: Record<CheckpointStatus, number> = { pending: 0, in_transit: 1, reached: 2 }

/**
 * A journey along ordered checkpoints (…final destination last) is valid when:
 *  - progress never increases down the route — an earlier checkpoint is always
 *    at least as advanced as a later one (you can't reach leg 2 before leg 1), and
 *  - at most one leg is "in transit" (a truck is only on one leg at a time).
 */
export function isValidCheckpointSequence(statuses: CheckpointStatus[]): boolean {
  let inTransit = 0
  for (let i = 0; i < statuses.length; i += 1) {
    if (statuses[i] === 'in_transit') {
      inTransit += 1
    }
    if (i > 0 && VALUE[statuses[i - 1]] < VALUE[statuses[i]]) {
      return false
    }
  }
  return inTransit <= 1
}

/**
 * Statuses an admin may set for the checkpoint at `index` without breaking the
 * sequence. The checkpoint's current status is always allowed (it's the active
 * selection); other statuses are allowed only if the resulting sequence is valid.
 */
export function allowedTransitions(
  statuses: CheckpointStatus[],
  index: number,
): CheckpointStatus[] {
  return CHECKPOINT_STATUSES.filter((status) => {
    if (status === statuses[index]) {
      return true
    }
    const next = statuses.slice()
    next[index] = status
    return isValidCheckpointSequence(next)
  })
}
